export const DEFAULT_PAGE_SIZE = 10;
export const LOCK_GROUP_TYPE_CHILD = 'CHILD';
export const LOCK_GROUP_TYPE_LOCK = 'LOCK';
export const sourceTypes = [
  {
    value: 'Web',
    label: 'content.web'
  },
  {
    value: 'Mobile',
    label: 'content.mobile'
  }
];
export const batteryLevels = [
  {
    value: 0,
    label: "0"
  },
  {
    value: 1,
    label: "1"
  },
  {
    value: 2,
    label: "2"
  },
  {
    value: 3,
    label: "3"
  },
  {
    value: 4,
    label: "4"
  },
  {
    value: 5,
    label: "5"
  },
  {
    value: 6,
    label: "6"
  }
]
export const appUserRoles = [
  {
    value: 1,
    label: 'constant.role.admin'
  },
  {
    value: 2,
    label: 'constant.role.user'
  }
]
